import Vue from 'vue'
import App from './app/index.vue'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'
// import Maska from 'maska'
import money from 'v-money'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BootstrapVue from 'bootstrap-vue'

// import VueDragula from 'vue-dragula'
require('./serviceWorkerRegistration')
// const VueDragula = require('vue-dragula');

Vue.config.productionTip = false

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
Vue.use(VueTheMask)
// Vue.use(Maska)
Vue.use(money, { precision: 2 })

// Vue.use(VueDragula)

store.dispatch('checkFont')

// setup pdf
// @ts-ignore
window.pdfMake.fonts.Roboto = {
	normal:
		window.location.origin +
		'/fonts/Assistant/static/Assistant-Regular.ttf',
	bold:
		window.location.origin + '/fonts/Assistant/static/Assistant-Medium.ttf',
	italics:
		window.location.origin + '/fonts/Assistant/static/Assistant-Light.ttf',
	bolditalics:
		window.location.origin +
		'/fonts/Assistant/static/Assistant-SemiBold.ttf',
}

// @ts-ignore
window.pdfMake.fonts.icon = {
	normal:
		window.location.origin +
		'/fonts/font-awesome/4.7.0/fontawesome-webfont.ttf',
}

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')

export const bus = new Vue()
